import React from 'react';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import ErrorBoundary from '../ErrorBoundary';

const TrackingTag = ({ email }) => (
  <img
    data-src={`//d1f0tbk1v3e25u.cloudfront.net/pc/h6aizkka/?e=${email}`}
    alt="booking confirmation"
    id="__tms_pc"
    height="1"
    width="1"
    className="lazyload"
  />
);

function BookingFormConfirmation({ current_user, setCurrentStep, email }) {
  if (current_user) {
    return (
      <section className="booking-form-confirmation-container">
        <h3>Thank You!</h3>
        <p className="desc">
          The owner of this property has received your request and will reply
          with more information.
        </p>
        <button
          aria-label="Continue Browsing"
          type="button"
          className="btn btn--blue-grad property_booking_request"
          onClick={() => {
            setCurrentStep(1);
            clearAllBodyScrollLocks();
            document.querySelector('body').style.overflow = '';
          }}
        >
          Continue Browsing
        </button>
        <TrackingTag email={email} />
      </section>
    );
  }

  return (
    <section className="booking-form-confirmation-container">
      <h3>Thank You!</h3>
      <p className="desc">
        We see that you haven’t created an account yet, this will make
        submitting booking requests easier in the future. Would you like to
        create an account now?
      </p>
      <a
        aria-label="Create an account"
        onClick={() => {
          clearAllBodyScrollLocks();
          document.querySelector('body').style.overflow = '';
        }}
        href={window.Routes.new_user_registration_path()}
        className="btn btn--blue-grad property_booking_request"
      >
        Create an Account
      </a>
      <button
        aria-label="Close Booking Form"
        name="Close Booking Form"
        type="button"
        className="underline"
        onClick={() => {
          setCurrentStep(1);
          clearAllBodyScrollLocks();
          document.querySelector('body').style.overflow = '';
        }}
      >
        No thanks
      </button>
      <TrackingTag email={email} />
    </section>
  );
}

export default function BookingFormConfirmationWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <BookingFormConfirmation {...props} />
    </ErrorBoundary>
  );
}
